<template>
  <apexchart ref="chart" type="line" height="350" :options="options" :series="series"/>
</template>

<script>
export default {
  name: 'TotalIncomeCombo',
  props: {
    periods: { type: Array, required: true },

    contributionEmployee: { type: Array, required: true }, // bar 1
    contributionEmployer: { type: Array, required: true }, // bar 2
    totalEmployees: { type: Array, required: true }        // line
  },
  computed: {
    series() {
      return [
        { name: 'Employee', type: 'column', data: this.contributionEmployee },
        { name: 'Employer', type: 'column', data: this.contributionEmployer },
        { name: 'No. of Employees', type: 'line', data: this.totalEmployees }
      ];
    },
    options() {
      return {
        chart: {
          id: 'pf-contributions',
          height: 350,
          type: 'line',
          stacked: false,   // ✅ no stacking, like demo
          toolbar:{ show:false, tools: {download: false, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false} }
        },
        stroke: {
          width: [1, 1, 3] // ✅ thinner bars, thicker line
        },
        dataLabels: {
          enabled: false   // ✅ disable for a clean look
        },
        xaxis: {
          categories: this.periods
        },
        yaxis: [
          {
            seriesName: "Employees' Contribution",
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#01524b' },
            labels: { style: { colors: '#01524b' }, formatter: v => this.fmt(v) },
            title: { text: "Employee Contribution", style: { color: '#01524b' } }
          },
          {
            seriesName: "Employer's Contribution",
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#8fd8d0' },
            labels: { style: { colors: '#8fd8d0' }, formatter: v => this.fmt(v) },
            title: { text: "Employer Contribution", style: { color: '#8fd8d0' } }
          },
          {
            seriesName: 'No. of Employees',
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#02d388' },
            labels: { style: { colors: '#02d388' }, formatter: v => Number.isFinite(v) ? Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 }) : ''  },
            title: { text: "Employees", style: { color: '#02d388' } },
            min: 8000,    // ✅ force y-axis to start near your lowest employee count
            max: 1000000,
            // max: 350     // ✅ so line appears stretched near the top
            forceNiceScale: true,
            tickAmount: 5
          }
        ],
        colors: ['#01524b', '#8fd8d0', '#02d388'], // ✅ match axes
        tooltip: {
          shared: true,
          intersect: false,
          // y: { formatter: v => this.fmt(v) }
          y: {
            formatter: (val, { seriesIndex }) => {
              if (val == null || isNaN(val)) return '';
              // only integers for employees (index 2)
              return seriesIndex === 2
                ? Number(val).toLocaleString('en-IN', { maximumFractionDigits: 0 })
                : this.fmt(val);
          }
        }
      },
        legend: {
          horizontalAlign: 'center',
          offsetX: 40
        }
      };
    }
  },
  methods: {
    fmt(v) {
      if (v === null || v === undefined || isNaN(v)) return '';
      return Number(v).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    },

    // Expose a clean API for parent to trigger a PNG download
    exportPng(filename = 'PF_Contributions.png') {
      const comp = this.$refs.chart;
      if (!comp || !comp.chart) {
        console.error('ApexCharts instance not ready');
        return;
      }
      // vue-apexcharts exposes the underlying ApexCharts instance as comp.chart
      comp.chart.dataURI().then(({ imgURI }) => {
        const a = document.createElement('a');
        a.href = imgURI;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }).catch(err => {
        console.error('Failed to export chart image:', err);
      });
    }
  }
};
</script>
